import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { IBaseInputProps } from "../../../../../interfaces/advancedSearch/IBaseInputProps";
import { ITextStyles } from "@fluentui/react";

export const CurrencyFieldInput: React.FunctionComponent<IBaseInputProps> = props => {
  const handleOnChange = React.useCallback((event: any, newValue?: string) => {
    props.handleValueChange(props.searchInputData?.index, newValue);
  }, []);

  const textStyles: Partial<ITextStyles> = { root: { width: "100%" } };
  return (
    <TextField
      label={props.displayName + " €"}
      step=".01"
      type="number"
      value={props.searchInputData?.value ?? ""}
      styles={textStyles}
      className="xb-sp-input"
      onChange={handleOnChange}
    />
  );
};

export default CurrencyFieldInput;
